import { toast } from "react-toastify";

const LEVEL = {
  DEFAULT: 0,
  SUCCESS: 1,
  WARNING: 2,
  INFORMATION: 3,
  ERROR: 4,
};

const defaultToast = (message, autoClose = true, closeButton = true) => {
  return toast(message, {
    position: "bottom-right",
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    closeButton: closeButton,
  });
};

const infoToast = (
  message,
  autoClose = true,
  closeButton = true,
  position = "bottom-right"
) => {
  return toast.info(message, {
    position: position,
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    closeButton: closeButton,
  });
};

const warningToast = (
  message,
  autoClose = true,
  closeButton = true,
  position = "bottom-right"
) => {
  return toast.warning(message, {
    position: position,
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    closeButton: closeButton,
  });
};

const successToast = (message, autoClose = true, closeButton = true) => {
  return toast.success(message, {
    position: "bottom-right",
    autoClose: autoClose,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    closeButton: closeButton,
  });
};

const errorToast = (message, autoClose = true, closeButton = true) => {
  let structured_error = null;
  try {
    structured_error = JSON.parse(message);
  } catch {
    structured_error = {
      error: message,
    };
  }
  return toast.error(
    structured_error.message !== undefined
      ? structured_error.message
      : Object.values(structured_error).join("\n"),
    {
      position: "bottom-right",
      autoClose: autoClose,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      closeButton: closeButton,
    }
  );
};

export {
  LEVEL,
  defaultToast,
  infoToast,
  errorToast,
  successToast,
  warningToast,
};
